var React = require('react');

function Distance (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M227.95 251.02c-27.68 4.97-35.28-37.2-7.56-42.15.63-.11 239.45-45.83 241.81 153.25 9.13 134.1.12 224.16 161.26 224.16 28.24 0 28.24 42.95 0 42.95-191.08 0-202.23-103.43-204.1-266.65-1.74-147.68-190.96-111.61-191.41-111.56zM655.31 585.1c-19.95-19.95 10.37-50.28 30.33-30.32l24.34 24.34 24.34-24.34c19.96-19.96 50.28 10.37 30.33 30.32l-24.35 24.35 24.35 24.35c19.95 19.96-10.37 50.27-30.33 30.32l-24.34-24.35-24.34 24.35c-19.96 19.95-50.28-10.36-30.33-30.32l24.34-24.35-24.34-24.35zM82.02 212.86c-19.95-19.95 10.37-50.27 30.32-30.32l24.36 24.35 24.34-24.35c19.96-19.95 50.28 10.37 30.33 30.32l-24.35 24.35 24.35 24.36c19.95 19.95-10.37 50.28-30.33 30.32l-24.34-24.35-24.36 24.35c-19.95 19.96-50.27-10.37-30.32-30.32l24.35-24.36-24.35-24.35z"}));
}

Distance.defaultProps = {"height":"100","width":"100","viewBox":"0 0 846.66 846.66"};

module.exports = Distance;

Distance.default = Distance;
